<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div class="rechange-title">
        <img class="icon-rechange" src="@/assets/login/icon-rechange.png" alt />
        注意：若刷脸失败，请尝试更换手机或刷脸APP，角度、光线也会影响刷脸结果
      </div>
      <div class="content flex" v-loading="loading">
        <div class="content-left">
          <div class="left-step">
            <div class="info-color">【步骤一】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-down.png" alt />
              <div>
                使用支付宝APP扫描右侧二维码
              </div>
            </div>
          </div>
          <div class="left-step">
            <div class="info-color">【步骤二】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-scan.png" alt />
              <div>
                刷脸过程中
                <span class="info-scan">请勿刷新页面</span>
              </div>
            </div>
          </div>
          <div class="left-step">
            <div class="info-color">【步骤三】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-step-finish.png" alt />
              <div>刷脸完成后，点击下方按钮《我已完成刷脸》刷新状态</div>
            </div>
          </div>
          <div class="left-step">
            <div class="info-color">【注意事项】</div>
            <div class="fz14 flex-center">
              <img class="icon-step" src="@/assets/login/icon-rechange.png" alt />
              <div>该人脸识别仅用于物理印章制作</div>
            </div>
          </div>
        </div>
        <div class="content-right">
          <img @click="getCode" class="img-code pointer" :src="codeUrl" alt />
          <div class="info-color mt10 mb20 pointer" @click="showViewer">查看大图</div>
          <div>若二维码失效，手动点击二维码刷新</div>
        </div>
      </div>
      <div class="bottom-area mt15">
        <el-button class="confirm-button" type="primary" @click="onConfirm">我已完成刷脸</el-button>
      </div>
      <el-image-viewer
        style="z-index: 2022;"
        v-if="isShowPics"
        :on-close="closeViewer"
        :url-list="srcList"
      />
    </el-dialog>
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import Cookies from "js-cookie";
export default {
  components: { ElImageViewer },
  data() {
    return {
      dialogVisible: false,
      flag: "",
      title: "",
      codeUrl: "",
      ruleData: {},
      checkId: "",
      loading: false,
      isShowPics: false,
      srcList: []
    };
  },
  methods: {
    show(data, title) {
      this.title = title + "刷脸认证";
      this.ruleData = data;
      this.codeUrl = "data:image/jpeg;base64," + data.faceCertifyUrl;
      this.srcList.push(this.codeUrl)
      // this.getCode();
      this.dialogVisible = true;
    },
    getCode() {
      this.loading = true;
      this.$http.post(this.$api.H5.createApply , JSON.stringify(this.ruleData)).then(res =>{
        if (res.data.code == 200){
          this.codeUrl = "data:image/jpeg;base64," + res.data.data.faceCertifyUrl;
          Cookies.set('PhysicalSeal', res.data.data.credential)
          this.loading = false
        }else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },

    showViewer() {
      this.isShowPics = true;
    },
    closeViewer() {
      this.isShowPics = false;
    },
    onConfirm() {
      this.$http
        .post(this.$api.H5.verifyFacial)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.applyId){
              this.handleClose();
              this.$emit("subPersonSeal" , res.data.data.applyId);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.srcList = [];
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 20px !important;
}

.rechange-title {
  box-sizing: border-box;
  height: 50px;
  margin: 0px auto 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: #fdf6eb;
  border-radius: 4px;
  border: 1px solid #faa000;
  color: #333;
}
.icon-rechange {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.content {
  padding: 20px 0;
  background: #f5f7fa;
  .content-left {
    width: 65%;
    padding: 20px;
    border-right: 1px solid #eee;
    .left-step {
      margin-bottom: 20px;
      text-align: left;
    }
  }
  .info-color {
    color: #407fff;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .info-scan {
    color: #faa000;
  }
  .icon-step {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .content-right {
    padding: 20px;
    .img-code {
      width: 200px;
      height: 200px;
    }
  }
}
.bottom-area {
  display: flex;
  justify-content: flex-end;
  .confirm-button {
    width: 150px;
    height: 32px;
    margin: 0 10px;
    padding: 0;
    background: #407fff;
  }
}
</style>
